import { useSpring, animated } from "react-spring"
import ReactDOM from "react-dom"
import clsx from "clsx"
import { CloseCircleIcon } from "../assets/icons"

const Modal = ({ isVisible, children, onToggle, className, header }) => {
  const animation = useSpring({
    opacity: isVisible ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 300 },
  })

  return ReactDOM.createPortal(
    <animated.div
      className="modal-wrapper"
      onClick={onToggle}
      style={{ ...animation }}
    >
      <div
        className={clsx(
          "modal-content thin-scrollbar",
          header && "pt-0",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {header && (
          <div className="sticky top-0 z-50 bg-white py-4 flex justify-between items-center">
            {header}
            <CloseCircleIcon
              className="w-6 h-6 cursor-pointer bg-accumin-neutral-white text-accumin-neutral-500"
              onClick={onToggle}
            />
          </div>
        )}
        {children}
      </div>
    </animated.div>,
    document.getElementById("root")
  )
}

export default Modal
